var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4954 17.2C12.8845 17.2 13.2 17.3791 13.2 17.6C13.2 17.8209 12.8845 18 12.4954 18H7.5046C7.11546 18 6.8 17.8209 6.8 17.6C6.8 17.3791 7.11546 17.2 7.5046 17.2H12.4954ZM11.6 9.4152V4.1848C11.6 3.42313 10.8871 2.8 10 2.8C9.11276 2.8 8.4 3.42303 8.4 4.1848V9.4152C8.4 10.1768 9.11288 10.8 10 10.8C10.8869 10.8 11.6 10.1767 11.6 9.4152ZM12.4 9.05087C12.4 10.4613 11.3229 11.6 10 11.6C8.67692 11.6 7.6 10.4613 7.6 9.05087V4.54913C7.6 3.13852 8.67686 2 10 2C11.323 2 12.4 3.13859 12.4 4.54913V9.05087ZM15.2 9.2C15.2 8.69911 15.1993 8.4 15.6 8.4C15.964 8.4 16 8.70056 16 9.2C16 12.2378 13.311 14.7995 10 14.7995C6.68916 14.7995 4 12.2377 4 9.2C4 8.70056 4 8.4 4.4 8.4C4.8 8.4 4.8 8.69304 4.8 9.2C4.8 11.4909 7.44847 14.1297 10 13.9713C12.5517 14.1297 15.2 11.6 15.2 9.2ZM9.6 14.7848C9.6 14.7848 9.87908 14.8025 10 14.8025C10.1209 14.8025 10.4 14.7848 10.4 14.7848V17.1934H9.6V14.7848Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.00c542a841bcde7f1f670bfa1af9aaa0.svg";
export { ForwardRef as ReactComponent };